/**
 * Marketo Forms
 */

let $ = jQuery;

let recaptchaWidgets = [];


let formIds = $('form[data-formId]').map(function () {
	return parseInt(this.getAttribute('data-formId'));
}).get();

let uniqueFormIds = formIds.filter(function (item, pos) {
	return formIds.indexOf(item) === pos;
});
let isSubmittable = false;
let validRecaptcha = false;

const mktoFormConfig = {
	podId: "//campaigns.snaplogic.com",
	munchkinId: "055-FYJ-916",
	formIds: uniqueFormIds,
	recaptcha: '6Ledx_4fAAAAALWyDO0gqqcWnuFmtm2eyqQuxtrT',
	fields: {
		recaptchaFinger: 'fingerprint',
	},
	actions: {
		formSubmit: 'form'
	},
	debug: {
		testBadFinger: false
	}
};

window.FormsPlus = window.FormsPlus || {
	allDescriptors: {},
	allMessages: {},
	detours: {}
};

const MKTOFORM_ID_PREFIX = 'mktoForm_',
	MKTOFORM_ID_ATTRNAME = 'data-formId';

let init = function (formId = null) {
	// Return early if page has no forms
	if (typeof MktoForms2 === 'undefined') {
		return;
	}
	// If passed a specific formId, only render that form
	if ( formId ) {
		mktoFormConfig.formIds = [ formId ];
	}

	mktoFormChain(mktoFormConfig);
	onFormRender();
};

/**
 * Renders all the Marketo Forms on the page
 *
 * @param config
 */
let mktoFormChain = function (config) {

	/* util */
	var arrayFrom = Function.prototype.call.bind(Array.prototype.slice);

	/* fix inter-form label bug! */
	MktoForms2.whenRendered(function (form) {
		var formEl = form.getFormElem()[0],
			rando = "_" + new Date().getTime() + Math.random();

		arrayFrom(formEl.querySelectorAll("label[for]")).forEach(function (labelEl) {
			var forEl = formEl.querySelector('[id="' + labelEl.htmlFor + '"]');
			if (forEl) {
				labelEl.htmlFor = forEl.id = forEl.id + rando;
			}
		});
	});

	/* chain, ensuring only one #mktoForm_nnn exists at a time */
	arrayFrom(config.formIds).forEach(function (formId) {

		let loadForm = MktoForms2.loadForm.bind(MktoForms2, config.podId, config.munchkinId, formId),
			formEls = arrayFrom(document.querySelectorAll("[" + MKTOFORM_ID_ATTRNAME + '="' + formId + '"]'));

		(function loadFormCb(formEls) {
			var formEl = formEls.shift();
			formEl.id = "mktoForm_" + formId;

			loadForm(function (form) {
				var formElm = form.getFormElem()[0];

				whenReady(form, formElm);
				onSubmit(form, formElm);
				onValidate(form, formElm);
				onSuccess(form, formElm);

				formEl.id = "";
				if (formEls.length) {
					loadFormCb(formEls);
				}
				FormsPlus.tagWrappers();
			});
		})(formEls);
	});
};

/**
 * Processes to run as part of loading the form
 *
 * We don't use the onLoad method of forms2 as that fires every time a form
 * renders on every form.
 *
 * @TODO implement destyleMktoForms() as part of Form Style Refactoring
 *
 * @param form
 * @param formElm
 */
let whenReady = function (form, formElm) {
	destyleMktoForm(form);
	cleanUpMarkup();
	setPrefill(form, formElm);
	setUTMParameters(form, formElm);
	addRequiredInstructions(form, formElm);
	setExternalLinks(form, formElm);
	// setRowClasses(form, formElm);
	setCTAText(form, formElm);
	addRecaptchaMessage(form, formElm);
	setRedshiftTrialValues(form, formElm);
	preCheckFields(form, formElm);
	showForm(form, formElm);
};

/**
 * Updates the button text during submission
 *
 * @param form
 * @param formElm
 */
let onSubmit = function(form, formElm) {
	form.onSubmit(function() {
		formElm.dataset.status = 'submitting';
	})
};


/**
 * Adds custom validation to the Form.
 *
 * The builtInValid is a boolean that comes back from Marketo after submission.
 * It is false when the form values do not pass all of the validation settings on
 * the Marketo side.
 *
 * @param form
 * @param formElm
 */
let onValidate = function (form, formElm) {

	form.onValidate(function (builtInValid) {

		clearErrors(form, formElm);

		if (!builtInValid) {
			// Disable Inputs while processing
			return;
		}

		form.submittable(isSubmittable);

		if ( !isSubmittable ) {

			// Disable Inputs while processing
			updateDisabledProperty(formElm, true);
			formElm.dataset.status = 'submitting';

			// Update the button text
			const buttonText = formElm.querySelector('.mktoButtonRow button[type="submit"]');
			buttonText.innerHTML = 'Please Wait<span class="button-arrow-wrapper"><svg class="button-arrow" width="20" height="17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 8.5h18m0 0L11.286 1M19 8.5 11.286 16" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg><span class="button-circle"></span></span>';

			// Check for valid recaptcha
			if ( !validRecaptcha ) {
				let recaptcha = validateRecaptcha(form, formElm);
				if ( !recaptcha ) {
					return false;
				}
			} else {
				validRecaptcha = true;
			}

			if ( !validRecaptcha ) {
				form.submittable(false);
				// Disable Inputs while processing
				updateDisabledProperty(formElm, false);
				formElm.dataset.status = 'error';
				buttonText.innerHTML = formElm.dataset.ctatext + '<span class="button-arrow-wrapper"><svg class="button-arrow" width="20" height="17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 8.5h18m0 0L11.286 1M19 8.5 11.286 16" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg><span class="button-circle"></span></span>';
				return;
			}

			// Skip email check for FDL Form
			if ( form.getId() === 1622 ) {
				form.submittable(true);
				return;
			}

			// First check for Partners Form
			if ( form.getId() === 1537 ) {
				checkPartnerEmail(form, formElm);
			} else {
				checkEmail(
					form,
					formElm,
					formElm.getAttribute('data-postid'),
					form.getId()
				);
			}
		}
	})
};


/**
 * Adds custom operations for Success of a form submission
 *
 * The attributes are set up based on the data attributes of the form and then
 * different tasks are run. We fire off our google analytics events here and submit
 * to the Free Trial API if necessary.
 *
 * We return false to not use the built in followUpUrl
 *
 * @param form
 * @param formElm
 */
let onSuccess = function (form, formElm) {

	form.onSuccess(function (values, followUpUrl) {

		let attributes = {
			eventCategory : formElm.getAttribute('data-eventCategory'),
			eventAction : formElm.getAttribute('data-eventAction'),
			eventLabel : formElm.getAttribute('data-eventLabel'),
			eventValue : formElm.getAttribute('data-eventValue'),
			formType : formElm.getAttribute('data-formType'),
			provisioning : formElm.getAttribute('data-provisioning'),
			successType : formElm.getAttribute('data-successType'),
			thankYouPage : formElm.getAttribute('data-thankYouPage'),
			existingUserPage : formElm.getAttribute('data-existingUserPage'),
			errorPage : formElm.getAttribute('data-errorPage'),
		};

        if (typeof window.rudderanalytics !== 'undefined') {
            const formVals = form.getValues();
            const formValsWithId = Object.assign({}, { anonymous_id: window.rudderanalytics.getAnonymousId() }, formVals);
            window.rudderanalytics.identify(formVals.Email, formValsWithId);
            window.rudderanalytics.track("marketo_form_submit", formValsWithId);
        }

		if ('download' === attributes.formType) {

			dataLayer.push({
				'event': 'ResourceClick',
				'resourceEventCategory': attributes.eventCategory,
				'resourceEventAction': attributes.eventAction,
				'resourceEventLabel': attributes.eventLabel,
			});

			setAssetCookie(formElm);

		} else {

			dataLayer.push({
				'event': 'marketoFormClick',
				'marketoEventCategory': attributes.eventCategory,
				'marketoEventAction': attributes.eventAction,
				'marketoEventLabel': attributes.eventLabel,
				'marketoEventValue': attributes.eventValue,
			});

			setAssetCookie(formElm);
		}

		if ( 'free-trial' === attributes.formType && 'true' === attributes.provisioning ) {
			loadSnapServiceRequest(form, formElm, attributes);
			return false;
		} else if (attributes.thankYouPage) {
			location.href = attributes.thankYouPage;
		}

		if ("thank-you-message" === attributes.successType) {
			const formWrapper = formElm.closest('.form-wrapper');
			formElm.style.display = 'none';
			formWrapper.querySelector('.landing-disclaimer').style.display = 'none';
			formWrapper.querySelector('.js-recaptcha-disclaimer').style.display = 'none';
			formWrapper.querySelector('.form--success-message').style.display = 'block';
		}

		return false;
	});
};

/**
 * Sends the user data to a specific SnapLogic endpoint for Free Trial creation
 *
 * When the form is for a Free Trial we take the form values and send them to the
 * SnapLogic API for that type of Free Trial. We have a few different kinds that we
 * scope to the Post ID of the page. Any others use the general Free Trial api.
 *
 * This service then redirects to the thankyou, existing-user, or error page
 *
 * @param form
 * @param formElm
 * @param attributes
 */
let loadSnapServiceRequest = function( form, formElm, attributes ) {

	let postId = formElm.getAttribute('data-postid');
	let formId = form.getId();

	if (postId === '10691' || postId === '10034') {
		snapServiceRequestDataScience(form.vals(), form, attributes);
	} else if (postId === '11745') {
		snapServiceRequestAgilisium(form.vals(), form, attributes);
	} else if (postId === '13256') {
		snapServiceRequestSAP(form.vals(), form, attributes);
	} else if (
		postId === '27628' ||
		postId === '28499'
	) {
		snapServiceRequestCDW(form.vals(), form, attributes);
	} else if (formId === 1537) {
		snapServiceRequestPartners(form.vals(), form, attributes);
	} else if (formId === 1622) {
		snapServiceRequestFDL(form.vals(), form, attributes);
	} else if (formId === 1732 ) {
		snapServiceRequestRedshift(form.vals(), form, attributes);
	} else if ( formId === 1772 ) {
		snapServiceRequestPartnerEnablement(form.vals(), form, attributes);
	} else if ( formId === 1827 ) {
		snapServiceRequestFlows(form.vals(), form, attributes);
	} else {
		snapServiceRequest(form.vals(),form, attributes);
	}
};

/**
 * Sends the post id from the forms data attributes to the set-asset-cookie endpoint
 *
 * @param formElm
 */
let setAssetCookie = function (formElm) {

	let data = {
		postId: formElm.getAttribute('data-postId'),
	};

	$.ajax({
		url: rbMarketoFormsObject.rest_url + 'snaplogic/v1/set-asset-cookie',
		method: 'POST',
		async: false,
		data: data,
		beforeSend: function (xhr) {
			xhr.setRequestHeader('X-WP-Nonce', rbMarketoFormsObject.nonce);
		},
		success: function (response) {
			return response;
		},
		error: function (error) {
			console.error(error);
		}
	})

};

/**
 * Sends the email to the check-email endpoint for verification
 *
 * Depending on the form type the email domain is checked against one or more
 * lists of blocked domains.
 *
 * If successful the isSubmittable value is set to true and the form is resubmitted
 *
 * We have to resubmit because the Marketo Form does not wait for the results of
 * the ajax call.
 *
 * @param form
 * @param formElm
 * @param postId
 * @param formId
 */
let checkEmail = function (form, formElm, postId, formId) {

	let vals = form.vals(),
		data = {
			postId,
			formId,
			email: vals.Email,
			type: formElm.getAttribute('data-formType'),
			blocklist: formElm.getAttribute('data-emailBlocklist')
		};

	$.ajax({
		url: rbMarketoFormsObject.rest_url + 'snaplogic/v1/check-email',
		method: 'POST',
		async: true,
		data: data,
		beforeSend: function (xhr) {
			xhr.setRequestHeader('X-WP-Nonce', rbMarketoFormsObject.nonce);
		},
		success: function (response) {

			// Check for Partners Form
			if ( formId === 1537 ) {
				location.href = formElm.getAttribute('data-existinguserpage');
				return false;
			}

			isSubmittable = true;
			form.submit();
		},
		error: function (error, statusText, errorThrown) {
			let code = '';

			if ( error.hasOwnProperty('responseText') ) {
				let response = JSON.parse(error.responseText);
				code = response.code;
			}

			if ('bad-email' === code) {
				displayEmailValidationError(form, error);
			} else if ('partner-email' === code) {
				displayPartnerEmailValidationError(form, error);
			}

			// Disable Inputs while processing
			updateDisabledProperty(formElm, false);
			formElm.dataset.status = 'error';

			return false;
		}
	});
};

let checkPartnerEmail = function( form, formElm) {
	let vals = form.vals(),
		data = {
			email: vals.Email,
			type: formElm.getAttribute('data-formType'),
		};

	$.ajax({
		url: rbMarketoFormsObject.rest_url + 'snaplogic/v1/check-partner-email',
		method: 'POST',
		async: true,
		data: data,
		beforeSend: function (xhr) {
			xhr.setRequestHeader('X-WP-Nonce', rbMarketoFormsObject.nonce);
		},
		success: function (response) {
			isSubmittable = true;
			form.submit();
		},
		error: function (error, statusText, errorThrown) {
			let code = '';

			if ( error.hasOwnProperty('responseJSON') ) {
				code = error.responseJSON.code;
			} else if ( error.hasOwnProperty('responseText') ) {
				code = JSON.parse(error.responseText).code;
			}

			if ('bad-email' === code) {
				displayEmailValidationError(form, error);
			} else if ('non-partner-email' === code) {
				location.href = formElm.getAttribute('data-existingUserPage');
			}

			// Disable Inputs while processing
			updateDisabledProperty(formElm, false);
			return false;
		}
	});
}

let displayEmailValidationError = function (form, error) {
	let emailElem = form.getFormElem().find("[name='Email']");
	let responseText = JSON.parse(error.responseText);
	form.showErrorMessage(responseText.message, emailElem);
};

let displayPartnerEmailValidationError = function (form, error) {
	let formWrapper = form.getFormElem().parent();
	let responseText = JSON.parse(error.responseText);
	formWrapper.html(responseText.message);
};

let displayReCaptchaValidationError = function(form, error) {
	let recaptchaElem = form.getFormElem().parent().find(".recaptcha-wrapper");
	$("<div class='mkto-error-row' role='alert'>"+error+"</div>").insertAfter(recaptchaElem);
}

let clearErrors = function(form, formElm) {
	form.getFormElem().parent().find('.mkto-error-row').remove();
}

/*
 * @author Sanford Whiteman
 * @version v1.104
 * @license MIT License: This license must appear with all reproductions of this software.
 *
 * Create a completely barebones, user-styles-only Marketo form
 * by removing inline STYLE attributes and disabling STYLE and LINK elements
 */
let destyleMktoForm = function (mktoForm, moreStyles) {
	let formEl = mktoForm.getFormElem()[0],
		arrayFrom = Function.prototype.call.bind(Array.prototype.slice);

	// remove element styles from <form> and children
	let styledEls = arrayFrom(formEl.querySelectorAll("[style]")).concat(formEl);
	styledEls.forEach(function (el) {
		el.removeAttribute("style");
	});

	// disable remote stylesheets and local <style>s
	let styleSheets = arrayFrom(document.styleSheets);
	styleSheets.forEach(function (ss) {
		if ([mktoForms2BaseStyle, mktoForms2ThemeStyle].indexOf(ss.ownerNode) != -1 || formEl.contains(ss.ownerNode)) {
			ss.disabled = true;
		}
	});

	if (!moreStyles) {
		formEl.setAttribute("data-styles-ready", "true");
	}
};

/**
 * Removes dom elements from the embedded Marketo Form
 *
 * These deal more with the default styling, and get in the
 * way of our custom styles.
 */
const cleanUpMarkup = function () {

	const elementsToRemove = [
		'.mktoClear',
		'.mktoOffset',
		'.mktoGutter',
	];

	elementsToRemove.forEach(el => {
		const elements = document.querySelectorAll(el);
		Array.prototype.forEach.call(elements, (node) => {
			node.parentNode.removeChild(node);
		})
	});
}

/**
 * Runs every time the form renders.
 *
 * Forms render when initially created and every time
 * the visibility rules alters the structure of the form.
 *
 * We need to set the row Classes when the GDPR Checkboxes
 * get added to the form for styling.
 */
const onFormRender = function () {

	if (typeof MktoForms2 === "undefined") {
		return;
	}

	MktoForms2.onFormRender(form => {
		destyleMktoForm(form);
		cleanUpMarkup();
	})
};

/**
 * Sets the form prefill values based on the Munchkin Tracking Cookie
 *
 * @param form
 * @param formElm
 */
let setPrefill = function(form, formElm) {

	if ( typeof mktoLead !== 'undefined' && Array.isArray(mktoLead.result) && mktoLead.result.length !== 0 ) {
		// set the first result as a local variable
		var mktoLeadFields = mktoLead.result[0];
		// map your results from the REST call to the corresponding field names on the form
		var prefillFields = {
			"Email" : mktoLeadFields.email,
			"FirstName" : mktoLeadFields.firstName,
			"LastName" : mktoLeadFields.lastName,
			"Company" : mktoLeadFields.company
		};
		// pass our prefillFields object into the form.view method to fill our fields
		form.vals(prefillFields);
	}
};

/**
 * Sets a class on each mktoFormRow element based on its contents
 *
 * @param form
 * @param formElm
 */
let setRowClasses = function (form, formElm) {
	let rows = $(formElm).find('.mktoFormRow');
	rows.each(function () {
		let name = $(this).find('input').attr('name');
		if (!name) {
			name = $(this).find('select').attr('name');
		}
		if (name) {
			$(this).addClass(name);
		} else {
			$(this).addClass($(this)[0].firstChild.classList[1]);
		}
	})
};

/**
 * Sets the custom CTA text for the submit button
 *
 * @param form
 * @param formElm
 * @returns {boolean}
 */
let setCTAText = function(form, formElm) {

	let cta = formElm.getAttribute('data-ctaText');
	let buttonArrow = "<span class='button-arrow-wrapper'><svg class='button-arrow' width='20' height='17' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 8.5h18m0 0L11.286 1M19 8.5 11.286 16' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'></svg><span class='button-circle'></div></span></button></span>"
	let button = $(formElm).find('button[type="submit"]');

	if ( !cta && button.length > 0 ) {
		button[0].innerHTML = button[0].innerHTML + ' ' + buttonArrow;
		return false;
	}

	if ( button.length > 0 ) {
		button[0].innerHTML = cta + buttonArrow;
	}

	return true;
};

/**
 * Grab UTM Parameters from URL and add to Marketo Form hidden fields
 *
 * @param form
 * @param formElm
 */
let setUTMParameters = function(form, formElm) {

	let utmQuery = decodeURIComponent(window.location.search.substring(1)),
		utmVariables = utmQuery.split('&'),
		formParams = {},
		ParameterName,
		i;

	const utmParams = [
		'utm_source',
		'utm_medium',
		'utm_campaign',
		'utm_content',
		'utm_term'
	];

	const valueExists = (value) => {
		return (value != null && value !== '' && value !== undefined)
	};

	const getUTMValue = (inputParameter) => {
		for (i = 0; i < utmVariables.length; i++) {
			ParameterName = utmVariables[i].split('=');
			if (ParameterName[0] === inputParameter) {
				return ParameterName[1] === null ? null : ParameterName[1];
			}
		}
	};

	utmParams.forEach(param => {
		var pValue = getUTMValue(param);

		if (valueExists(pValue)) {
			let inputName = param + '__c';
			formParams[inputName] = pValue;
		}
	});

	// Check for other utm values to update from the form object
	let overrides = {
		uTMReferral: formElm.getAttribute('data-utmReferral'),
	};
	for (const [key, value] of Object.entries(overrides)) {
		if (value) {
			formParams[key] = value;
		}
	}

	form.setValues(formParams);
};

let addRequiredInstructions = function( form, formElm ) {
	let buttonRow = formElm.querySelector('.mktoButtonRow');
	let instructionRow = formElm.parentNode.querySelector('.js-form-instructions');
	if(!instructionRow) {
		return;
	}
	formElm.insertBefore(instructionRow, buttonRow);
	instructionRow.style.display = 'block';
}

let setExternalLinks = function( form, formElm ) {
	let links = formElm.querySelectorAll('a');
	links.forEach( (link) => {
		//console.log(link);
		link.setAttribute('target', '_blank');
		link.setAttribute('rel', 'noreferrer noopener');
	})
}

/**
 * Adds additional fields to the form for the Amazon Redshift Free Trial
 *
 * Adds a password field and hidden fields for each of the query parameters.
 * None of these fields are registered with Marketo, and are ignored on a
 * submission to Marketo.
 *
 * The RedShift Free Trial is form ID 1732
 *
 * The hidden fields are added and if there are no AWS parameters passed they are
 * still added and are just empty. These all get passed to the REST endpoint and
 * removed from the SnapLogic POST if empty, but we need to first send them to our
 * own backend.
 *
 * If the accountID dbName and Username are not present, the password field is not
 * added to the form.
 *
 * @param form
 * @param formElm
 */
let setRedshiftTrialValues = function (form, formElm) {

	if (form.getId() !== 1732) {
		return;
	}

	const accountId = getQueryVariable('accountId'),
		region = getQueryVariable('region'),
		clusterUrl = getQueryVariable('clusterUrl'),
		dbPort = getQueryVariable('dbPort'),
		dbName = getQueryVariable('dbName'),
		username = getQueryVariable('username'),
		buttonRow = formElm.querySelector('.mktoPlaceholderEmail_Opt_In__c');

	$(formElm).append(
		"<input id='qp-accountId' type='hidden' name='accountId' value='" + accountId + "'>" +
		"<input id='qp-region' type='hidden' name='region' value='" + region + "'>" +
		"<input id='qp-clusterUrl' type='hidden' name='clusterUrl' value='" + clusterUrl + "'>" +
		"<input id='qp-dbPort' type='hidden' name='dbPort' value='" + dbPort + "'>" +
		"<input id='qp-dbName' type='hidden' name='dbName' value='" + dbName + "'>" +
		"<input id='qp-username' type='hidden' name='username' value='" + username + "'>"
	);

	if ( !accountId && !dbName && !username ) {
		return;
	}

	$("" +
		"<div class='mktoFormRow Password'>" +
		"<div class='mktoFormCol'>" +
		"<div class='mktoFieldWrap'>" +
		"<label for='redshift-db-pass' class='mktoLabel mktoLabelVisible'>Redshift Details:</label>" +
		"<input type='password' name='redshift-db-pass' id='redshift-db-pass' placeholder='Redshift Database Password'>" +
		"<p class='redshift-ip-note'>See <a href='https://community.snaplogic.com/t/how-to-grant-access-to-snaplogics-ips-for-amazon-redshift/9857' target='_blank'>our documentation</a> on how to <strong>grant access to SnapLogic's IPs</strong> for Amazon Redshift</p>" +
		"</div>" +
		"</div>" +
		"</div>").insertBefore(buttonRow);
};

/**
 * Adds the required Google reCAPTCHA message
 *
 * We need to add this to the user flow of the form because we have hidden the
 * recaptcha bade in the bottom right.
 *
 * @param form
 * @param formElm
 */
const addRecaptchaMessage = function(form, formElm) {
	$(formElm).parent().find('.js-recaptcha-disclaimer').show();
}


/**
 * Validates Google reCAPTCHA
 *
 * Uses the grecaptcha functions to get the users fingerprint
 *
 * Sends the fingerprint to the rest api endpoint where it is validated on the
 * backend with the secure key.
 *
 * Repurposed from Sanford Whiteman's reCAPTCHA v3 v1.1.2 pen
 *
 * @link https://codepen.io/figureone/pen/yLgKXge?editors=0010
 * @param form
 * @param formElm
 * @returns {boolean}
 */
const validateRecaptcha = function (form, formElm) {
	form.locked = false;

	// Make sure the recaptcha script is loaded
	if ( typeof grecaptcha === 'undefined' ) {
		displayRecaptchaErrorMessage(form, formElm);
		return false;
	}

	// Recaptcha is enabled, and is not yet valid
	grecaptcha.ready(function () {
		grecaptcha.execute(mktoFormConfig.recaptcha, {
			action: mktoFormConfig.actions.formSubmit
		})
			.then(function (recaptchaFinger) {
				var mktoFields = {};
				if (form.locked === false) {

					form.locked = true;
					if (!mktoFormConfig.debug.testBadFinger) {
						mktoFields[mktoFormConfig.fields.recaptchaFinger] = recaptchaFinger;
					} else {
						mktoFields[mktoFormConfig.fields.recaptchaFinger] = 'known bad fingerprint ' + Math.random();
					}

					mktoFields.path = window.location.href;

					$.ajax({
						url: rbMarketoFormsObject.rest_url + 'snaplogic/v1/validate-recaptcha',
						method: 'POST',
						data: mktoFields,
						beforeSend: function (xhr) {
							xhr.setRequestHeader('X-WP-Nonce', rbMarketoFormsObject.nonce);
						},
						success: function (response) {
							let parsed = JSON.parse(response);

							if ( parsed.success && isHumanScore(parsed.score) ) {
								validRecaptcha = true;
								form.locked = false;
								form.submit();
							} else {
								displayRecaptchaErrorMessage(form, formElm);
								return false;
							}
						},
						error: function( error ) {
							console.log(error);
						}
					})
				} else {
					console.log('secondary recaptcha response resolved');
				}
			})
	})
	return false;
}

/**
 *
 * @param form
 * @param formElm
 */
const displayRecaptchaErrorMessage = function(form, formElm) {
	var buttonRow = formElm.querySelector('.mktoButtonRow');
	$("<div class='alert alert-warning text-center' role='alert' id='recaptcha-row'><strong>There was an error with your recaptcha submission. Please try again later.</strong></div>").insertBefore(buttonRow);

	const buttonText = formElm.querySelector('.mktoButtonRow button[type="submit"]');
	buttonText.innerHTML = formElm.dataset.ctatext + '<span class="button-arrow-wrapper"><svg class="button-arrow" width="20" height="17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 8.5h18m0 0L11.286 1M19 8.5 11.286 16" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg><span class="button-circle"></span></span>';
	formElm.dataset.status = 'error';
	form.submittable(false);
}

/**
 * Checks the Recaptcha Score
 *
 * The success response from the recaptcha validation includes a score from 0 - 1.
 * Zero being a robot, One being a human, and the scale of confidence in between.
 *
 * We will allow anyone that is a 0.6 and above.
 *
 * Since it is difficult to compare a floating point number, it is easier to just use a
 * switch to check the individual cases to allow through. Note, a 1 is never really returned
 * but it could be so I've included it here.
 *
 * @param score
 * @returns {boolean}
 */
const isHumanScore = function( score ) {
	switch( score ) {
		case 1.0:
		case 0.9:
		case 0.8:
		case 0.7:
		case 0.6:
			return true;

		default:
			return false;
	}
}

/**
 * Pre-checks fields on various forms
 *
 * This is for forms that have specific fields that need to be pre-checked
 *
 * @param form
 * @param formElm
 */
const preCheckFields = function(form, formElm) {
	preCheck2225(form, formElm);
}

/**
 * Pre-check fields on the form with ID 2225
 *
 * Checks the checkbox with the "I want to learn more!" text
 *
 * @param form
 * @param formElm
 */
const preCheck2225 = function(form, formElm) {
	if (form.getId() !== 2225) {
		return;
	}

	const checkbox = formElm.querySelector('input[name="tempField1c"]');
	checkbox.checked = true;
}

/**
 * Displays the hidden form with a default fade in
 */
let showForm = function (form, formElm) {
	formElm.dataset.status = 'ready';

	const formWrapper = formElm.closest('.form-wrapper');
	const formWrapperForm = formWrapper.querySelector('.form-wrapper__form');
	const formWrapperSpinner = formWrapper.querySelector('.form-wrapper__spinner');

	formWrapperForm.style.display = 'block';
	formWrapperSpinner.style.display = 'none';
};

/**
 * Updates the disabled property
 *
 * Pass in the form and the status. True disables, False re-enables.
 *
 * @param formEl
 * @param status
 */
let updateDisabledProperty = function( formEl, status ) {
	let $inputs = $(formEl).find('input');
	let $selects = $(formEl).find('select');
	let $submit = $(formEl).find('[type="submit"]');
	$inputs.each(function() {
		$(this).prop('disabled', status);
	});
	$selects.each(function() {
		$(this).prop('disabled', status);
	});
	$submit.each(function() {
		$(this).prop('disabled', status);
	})
};

/**
 * Gets a value of a Query Variable
 *
 * If the value doesn't exist, and empty string is returned
 *
 * @param variable
 * @returns {string}
 */
const getQueryVariable = function ( variable ) {
	var query = window.location.search.substring(1);
	var vars = query.split("&");
	for ( var i = 0; i < vars.length; i++ ) {
		var pair = vars[i].split("=");
		if(pair[0] === variable) {
			return pair[1];
		}
	}
	return '';
};

let snapServiceRequest = function(vals,form,attributes) {
	console.log('snapServiceRequest');
	var snapServiceToken = 'Bearer x3GFFXbFOEjPLRb1ksVJ2mXCkQ9OwD0S';
	var snapServiceURL = 'https://elastic.snaplogic.com:443/api/1/rest/slsched/feed/snaplogic/projects/marketo/post_data_task?firstname=' + vals.FirstName + '&lastname=' + vals.LastName + '&email=' + encodeURIComponent(vals.Email) + '&database_type=MySQL';

	jQuery.ajax({
		url: snapServiceURL,
		dataType: 'json',
		type: 'post',
		contentType: 'application/json',
		data: '{}',
		xhrFields: {
			withCredentials: true
		},
		headers: {
			'Authorization': snapServiceToken,
			'content-type': 'application/json'
		},
		success: handleServiceData,
		error: function (jqXhr, textStatus, errorThrown) {
			console.log(errorThrown);
		}
	});

	function handleServiceData(data, status, jQxhr) {
		var thisResponse = jQxhr.responseText;
		var trimResp = thisResponse.slice(2, -2);
		thisParse = jQuery.parseJSON(trimResp);
		var thisStatus = thisParse.status;

		if (thisStatus === 200) {
			location.href = attributes.thankYouPage;
		} else if (thisStatus === 400) {
			location.href = attributes.existingUserPage;
		} else if (thisStatus === 500) {
			location.href = attributes.errorPage;
		} else {
			location.href = attributes.thankYouPage;
		}
	}

	return false;

}



let snapServiceRequestDataScience = function(vals, form, attributes) {

	var buttonRow = jQuery('.mktoButtonRow');
	var message = "<span class='processing-message'>Please be patient. We're checking this and that before we get you into the correct free trial program.</span>";
	buttonRow.append(message);

	var snapServiceToken = 'Bearer 1JgLu5PF1OgdkqZKNUD9Hv4hsGkOpah9';
	var snapServiceURL = 'https://elastic.snaplogic.com:443/api/1/rest/slsched/feed/SLPROD/CustomerSuccess/DSTrials/CreateDSTrialUser?firstname=' + vals.FirstName + '&lastname=' + vals.LastName + '&email=' + encodeURIComponent(vals.Email) + '&database_type=MySQL';

	jQuery.ajax({
		url: snapServiceURL,
		dataType: 'json',
		type: 'post',
		contentType: 'application/json',
		data: '{}',
		xhrFields: {
			withCredentials: true
		},
		headers: {
			'Authorization': snapServiceToken,
			'content-type': 'application/json'
		},
		success: handleServiceData,
		error: function (jqXhr, textStatus, errorThrown) {
			console.log(errorThrown);
		}
	});

	function handleServiceData(data, status, jQxhr) {
		var thisStatus = jQxhr.responseJSON.http_status_code;

		if (thisStatus === 200) {
			location.href = attributes.thankYouPage;
		} else if (thisStatus === 400) {
			location.href = attributes.existingUserPage;
		} else if (thisStatus === 500) {
			location.href = attributes.errorPage;
		} else {
			location.href = attributes.errorPage;
		}
	}

	return false;

}

let snapServiceRequestAgilisium = function(vals, form, attributes) {

	var buttonRow = jQuery('.mktoButtonRow');
	var message = "<span class='processing-message' style='color: #333333;'>Please be patient. We're checking this and that before we get you into the correct free trial program.</span>";
	buttonRow.append(message);

	var snapServiceToken = 'Bearer USfeF7deHqsq4RtT38Zb41wsLg1Kar61';
	var snapServiceURL = '\n' +
		'https://elastic.snaplogic.com:443/api/1/rest/slsched/feed/SLPROD/CustomerSuccess/AWSQuickStartTrial/CreateAWSQSTrialUsersTask?firstname=' + vals.FirstName + '&lastname=' + vals.LastName + '&email=' + encodeURIComponent(vals.Email) + '&database_type=MySQL';

	jQuery.ajax({
		async: true,
		url: snapServiceURL,
		dataType: 'json',
		method: 'POST',
		contentType: 'application/json',
		crossDomain: true,
		data: '{}',
		xhrFields: {
			withCredentials: true
		},
		headers: {
			'Authorization': snapServiceToken,
			'content-type': 'application/json'
		},
		success: handleServiceData,
		error: function (jqXhr, textStatus, errorThrown) {
			console.error(errorThrown);
		}
	});

	function handleServiceData(data, status, jQxhr) {

		var thisStatus = jQxhr.responseJSON.http_status_code;

		if (thisStatus === 200) {
			location.href = attributes.thankYouPage;
		} else if (thisStatus === 400) {
			location.href = attributes.existingUserPage;
		} else if (thisStatus === 500) {
			location.href = attributes.errorPage;
		} else {
			location.href = attributes.errorPage;
		}
	}

	return false;

}

let snapServiceRequestSAP = function(vals, form, attributes) {
	var buttonRow = jQuery('.mktoButtonRow');
	var message = "<span class='processing-message' style='color: #333333;'>Please be patient. We're checking this and that before we get you into the correct free trial program.</span>";
	buttonRow.append(message);

	var snapServiceToken = 'Bearer Dl2d99wCigZDATy43jJKUnnvMHklOLht';
	var snapServiceURL = '\n' +
		'https://elastic.snaplogic.com:443/api/1/rest/slsched/feed/SLPROD/CustomerSuccess/SAPTrial/CreateSAPTrialUsers%20Task?firstname=' + vals.FirstName + '&lastname=' + vals.LastName + '&email=' + encodeURIComponent(vals.Email) + '&database_type=MySQL';

	jQuery.ajax({
		async: true,
		url: snapServiceURL,
		dataType: 'json',
		method: 'POST',
		contentType: 'application/json',
		crossDomain: true,
		data: '{}',
		xhrFields: {
			withCredentials: true
		},
		headers: {
			'Authorization': snapServiceToken,
			'content-type': 'application/json'
		},
		success: handleServiceData,
		error: function (jqXhr, textStatus, errorThrown) {
			console.error(errorThrown);
		}
	});

	function handleServiceData(data, status, jQxhr) {

		var thisStatus = jQxhr.responseJSON.http_status_code;

		if (thisStatus === 200) {
			location.href = attributes.thankYouPage;
		} else if (thisStatus === 400) {
			location.href = attributes.existingUserPage;
		} else if (thisStatus === 500) {
			location.href = attributes.errorPage;
		} else {
			location.href = attributes.errorPage;
		}
	}

	return false;
}

let snapServiceRequestPartners = function(vals, form, attributes) {

	var data = {
		firstName: vals.FirstName,
		lastName: vals.LastName,
		email: vals.Email,
	}
	jQuery.ajax({
		url: rbMarketoFormsObject.rest_url + 'snaplogic/v1/partner-signup',
		method: 'POST',
		async: true,
		data: data,
		timeout: 120000,
		beforeSend: function (xhr) {
			xhr.setRequestHeader('X-WP-Nonce', rbMarketoFormsObject.nonce);
		},
		success: function(data, status, jQxhr) {
			location.href = attributes.thankYouPage;
		},
		error: function(jqXhr, textStatus, errorThrown) {
			console.error(jqXhr.responseText);
			location.href = attributes.errorPage;
		},
	});
}

let snapServiceRequestFDL = function(vals, form, attributes) {
	console.log('snapServiceRequestFDL');
	var data = {
		email: vals.Email,
		firstName: vals.FirstName,
		lastName: vals.LastName,
	};
	jQuery.ajax({
		url: rbMarketoFormsObject.rest_url + 'snaplogic/v1/fdl',
		method: 'POST',
		async: true,
		data: data,
		beforeSend: function (xhr) {
			xhr.setRequestHeader('X-WP-Nonce', rbMarketoFormsObject.nonce);
		},
		success: handleServiceData,
		error: function(response) {
			console.error(response);
		}
	});

	function handleServiceData(data, status, jQxhr) {
		var thisStatus = false;
		if ( jQxhr.hasOwnProperty('status' )) {
			thisStatus = jQxhr.status;
		}

		if (thisStatus === 200) {
			location.href = attributes.thankYouPage;
		} else if (thisStatus === 400) {
			location.href = attributes.existingUserPage;
		} else if (thisStatus === 500) {
			location.href = attributes.errorPage;
		} else {
			location.href = attributes.errorPage;
		}
	}
}

let snapServiceRequestRedshift = function(vals, form, attributes) {
	console.log('snapServiceRedshift');

	// Password field is only added to the form when certain query parameters are
	// present. If it's not added the querySelector will return null.
	var password = document.querySelector('[name="redshift-db-pass"]'),
		passwordValue = '';

	if (password) {
		passwordValue = password.value;
	}

	var data = {
		email: vals.Email,
		firstName: vals.FirstName,
		lastName: vals.LastName,
		clusterUrl: document.getElementById('qp-clusterUrl').value,
		dbName: document.getElementById('qp-dbName').value,
		dbPort: document.getElementById('qp-dbPort').value,
		username: document.getElementById('qp-username').value,
		accountId: document.getElementById('qp-accountId').value,
		region: document.getElementById('qp-region').value,
		password: passwordValue,
	}

	jQuery.ajax({
		url: rbMarketoFormsObject.rest_url + 'snaplogic/v1/redshift',
		method: 'POST',
		async: false,
		data: data,
		beforeSend: function (xhr) {
			xhr.setRequestHeader('X-WP-Nonce', rbMarketoFormsObject.nonce);
		},
		success: function(data, status, xhr) {
			var body = JSON.parse(data);

			if ( !body.length && !body[0].hasOwnProperty('result') ) {
				location.href = attributes.errorPage;
				return;
			}

			if ( body[0]['result'] === 'success' ) {
				location.href = attributes.thankYouPage;
			} else if ( body[0]['result'] === 'failure' ) {
				location.href = attributes.thankYouPage;
			} else {
				console.error('An unknown error occurred');
				location.href = attributes.thankYouPage;
			}
		},
		error: function(response) {
			console.error(response);
			location.href = attributes.errorPage;
		}
	});
}

let snapServiceRequestPartnerEnablement = function(vals, form, attributes) {
	console.log('snapServiceRequestPartnerEnablement');
	var data = {
		firstName: vals?.FirstName,
		lastName: vals?.LastName,
		email: vals?.Email,
		title: vals?.Title,
		company: vals?.Company,
		phone: vals?.Phone,
		country: vals?.Country,
		state: vals?.State,
		postalCode: vals?.PostalCode,
		partnerId: vals?.Partner_ID__c,
		partnerRole: vals?.Partner_Role__c,
		onlineTraining: vals?.Online_Training__c,
		enterYourCompanyDomain: vals?.enterYourCompanyDomain,
	}
	console.log(data);
	jQuery.ajax({
		url: rbMarketoFormsObject.rest_url + 'snaplogic/v1/partner-enablement-signup',
		method: 'POST',
		async: true,
		data: data,
		timeout: 120000,
		beforeSend: function (xhr) {
			xhr.setRequestHeader('X-WP-Nonce', rbMarketoFormsObject.nonce);
		},
		success: function(data, status, jQxhr) {
			console.log(data);
			location.href = attributes.thankYouPage;
		},
		error: function(jqXhr, textStatus, errorThrown) {
			console.error(jqXhr.responseText);
			location.href = attributes.errorPage;
		},
	});
}

let snapServiceRequestCDW = function(vals, form, attributes) {
	console.log('snapServiceRequestCDW');
	var data = {
		firstName: vals?.FirstName,
		lastName: vals?.LastName,
		email: vals?.Email,
	}
	jQuery.ajax({
		url: rbMarketoFormsObject.rest_url + 'snaplogic/v1/free-trial-cdw',
		method: 'POST',
		async: true,
		data: data,
		timeout: 120000,
		beforeSend: function (xhr) {
			xhr.setRequestHeader('X-WP-Nonce', rbMarketoFormsObject.nonce);
		},
		success: function(data) {
			location.href = attributes.thankYouPage;
		},
		error: function(data) {
			console.error(data.responseText);
			location.href = attributes.errorPage;
		},
	});
}

let snapServiceRequestFlows = function(vals, form, attributes) {
	console.log('snapServiceRequestFlows');
	var data = {
		firstName: vals?.FirstName,
		lastName: vals?.LastName,
		email: vals?.Email,
	}
	jQuery.ajax({
		url: rbMarketoFormsObject.rest_url + 'snaplogic/v1/free-trial-flows',
		method: 'POST',
		async: true,
		data: data,
		timeout: 120000,
		beforeSend: function (xhr) {
			xhr.setRequestHeader('X-WP-Nonce', rbMarketoFormsObject.nonce);
		},
		success: function(data) {
			location.href = attributes.thankYouPage;
		},
		error: function(data) {
			console.error(data.responseText);
			location.href = attributes.errorPage;
		},
	});
}

FormsPlus.tagWrappers = function tagWrappers() {
	/* common vars & aliases */
	var ANCESTORS_STOR = '.mktoFormRow',
		INPUTS_STOR = 'INPUT,SELECT,TEXTAREA,BUTTON',
		attrTag = 'data-wrapper-for',
		_forEach = Array.prototype.forEach;

	/* utility fn to tag wrapper containers with inner form inputs */
	function tagMktoWrappers(formEl) {
		let previous = '';
		_forEach.call(formEl.querySelectorAll(ANCESTORS_STOR), function (ancestor) {
			ancestor.setAttribute(attrTag, '');
			_forEach.call(ancestor.querySelectorAll(INPUTS_STOR), function (input) {
				if ( previous === input.getAttribute('name') ) {
					return;
				}
				var currentTag = ancestor.getAttribute(attrTag);
				ancestor.setAttribute(attrTag, [currentTag ? currentTag : '', input.name].join(' ').trim());
				previous = input.getAttribute('name');
			});
		});
	}

	MktoForms2.whenRendered(function (form) {
		var formEl = form.getFormElem()[0];
		tagMktoWrappers(formEl);
	});

};

init();

document.addEventListener('buildForms', (e) => {
	console.log(e);
	init(e.detail);
});
